import { LmgService } from "../resource";

const FinanceModule = {
  namespaced: true,
  state: {
    datas: [],
    summary: {
      statuses: [],
      persons: [],
      cash_clear: { cleared_amount: 0, not_cleared_amount: 0 },
      quick_pay: { count: 0, amount: 0 },
    },
    finance_status: [
      { ID: 0, Name: "ทั้งหมด" },
      { ID: 1, Name: "ยังไม่สร้างรายการวางบิล" },
      { ID: 2, Name: "สร้างรายการวางบิล ยังไม่ได้ชำระเงิน" },
      { ID: 3, Name: "ชำระเงินแล้ว" },
      { ID: 4, Name: "ยกเลิก" },
    ],
    isLoading: false,
    isLoadingSummary: false,
    _listSeq: 0,
    _summarySeq: 0,
  },
  mutations: {
    SET_DATAS(state, payload) {
      state.datas = payload;
    },
    SET_SUMMARY(state, payload) {
      state.summary = payload;
    },
  },
  actions: {
    async listData({ commit, state }, payload) {
      state._listSeq += 1;
      const mySeq = state._listSeq;
      state.isLoading = true;
      try {
        const data = await LmgService.FinanceList(payload);
        if (mySeq !== state._listSeq) return;
        commit("SET_DATAS", data.data.Data == null ? [] : data.data.Data);
        state.isLoading = false;
      } catch (err) {
        if (mySeq !== state._listSeq) return;
        commit("SET_DATAS", []);
        state.isLoading = false;
      }
    },
    async getSummary({ commit, state }, payload) {
      state._summarySeq += 1;
      const mySeq = state._summarySeq;
      state.isLoadingSummary = true;
      const empty = { statuses: [], persons: [], cash_clear: { cleared_amount: 0, not_cleared_amount: 0 }, quick_pay: { count: 0, amount: 0 } };
      try {
        const data = await LmgService.FinanceSummary(payload);
        if (mySeq !== state._summarySeq) return;
        // Backend uses r.Set → payload lands on Datum, not Data.
        commit("SET_SUMMARY", data.data.Datum || empty);
        state.isLoadingSummary = false;
      } catch (err) {
        if (mySeq !== state._summarySeq) return;
        commit("SET_SUMMARY", empty);
        state.isLoadingSummary = false;
      }
    },
  },
  getters: {
    getData(state) {
      return state.datas;
    },
    getSummary(state) {
      return state.summary;
    },
    getFinanceStatus(state) {
      return state.finance_status;
    },
    isLoading(state) {
      return state.isLoading;
    },
    isLoadingSummary(state) {
      return state.isLoadingSummary;
    },
  },
};

export default FinanceModule;
